import { LineChart } from '@/components/charts/LineChart';
import { Text } from '@/components/ui';

interface TicketsChartProps {
  data?: { week: string; value: number }[];
  totalTickets?: number;
}

export function TicketsChart({ data, totalTickets = 0 }: TicketsChartProps) {
  return (
    <div className="bg-base-white border-transparent-dark-12 p-xs rounded-2xl border">
      <Text variant="label" strong>
        Tickets Processados
      </Text>
      <Text variant="label" size="xs" className="text-neutral-muted">
        <strong className="text-neutral-default font-medium">{totalTickets}</strong> no período
        informado
      </Text>

      <LineChart data={data} unit="tickets" />
    </div>
  );
}
